const UploadImage = ({ width = '38', height = '28', fill = '#BEBEBE' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12V15H22V17H19V20H17V17H14V15H17V12H19ZM19.0082 0C19.556 0 20 0.44495 20 0.9934V10H18V2H2V15.999L12 6L15 9V11.829L12 8.8284L4.827 16H12V18H0.9918C0.44405 18 0 17.5551 0 17.0066V0.9934C0 0.44476 0.45531 0 0.9918 0H19.0082ZM6 4C7.10457 4 8 4.89543 8 6C8 7.1046 7.10457 8 6 8C4.89543 8 4 7.1046 4 6C4 4.89543 4.89543 4 6 4Z"
        fill="#BDBCBC"
      />
    </svg>
  );
};

export default UploadImage;
